import { commonComponents as cc } from "@/components/common";
import { cn } from "@/lib/utils";
import type { SizeT } from "@/types/zod/common";
import { Calendar } from "lucide-react";

import CardTemplate from "@/components/common/CardTemplate";
import CardTemplateTitle from "@/components/common/CardTemplateTitle";
import type { EntryViewT } from "@/types/database/entries";
import { useState } from "react";
import { sortEntryValuesView } from "../../entries/services/sortEntryValuesView";
import EntryCardEntryValues from "../../entry-values/components/EntryCardEntryValues";
import { ObservationEntryValueEditDialog } from "./ObservationEntryValueEditDialog";

interface Props {
	entry: EntryViewT;
	size?: SizeT;
	className?: string;
	editable?: boolean;
}
const ObservationEntryValuesCard = ({
	entry,
	size,
	className,
	editable,
}: Props) => {
	const [isEditingValues, setIsEditingValues] = useState(false);
	const headerContent = (
		<CardTemplateTitle
			title={
				<cc.IconDetail
					icon={<Calendar size={24} />}
					words={entry.timing_label ?? "No Timing Label"}
				/>
			}
			dateTime={entry.calculated_entry_time as string}
			size={size}
			editable={editable}
			editButton={
				<cc.EditButton>
					<button
						type="button"
						onClick={() => setIsEditingValues(!isEditingValues)}
					>
						{isEditingValues ? "Done" : "Edit"}
					</button>
				</cc.EditButton>
			}
		/>
	);

	const bodyContent = isEditingValues ? (
		sortEntryValuesView(entry.entry_values)?.map((ev) => (
			<ObservationEntryValueEditDialog
				key={ev.entry_value_id}
				diaryId={entry.diary_id as string}
				observationId={entry.observation_id as string}
				entryId={entry.entry_id as string}
				entryValueId={ev.entry_value_id as string}
			/>
		))
	) : (
		<EntryCardEntryValues size={size} entryValues={entry.entry_values} />
	);

	return (
		<CardTemplate
			size={size}
			className={cn("border-slate-300 bg-white", className)}
			headerContent={headerContent}
			bodyContent={bodyContent}
		/>
	);
};

export default ObservationEntryValuesCard;
